import * as React from 'react';
import getStore from 'owa-calendar-sharing/lib/store/sharingStore';
import { CalendarSharingDialogComponent } from 'owa-calendar-sharing';
import { hideCalendarSharingPermissionsDialog } from 'owa-calendar-sharing/lib/actions/calendarSharing';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { observer } from 'mobx-react';

/**
 *  Modal wrapper for Calendar sharing component
 */
export default observer(function CalendarUpdatesSection() {
    const onDismissCalendarSharingPermissions = () => {
        hideCalendarSharingPermissionsDialog();
    };

    return getStore().viewState ? (
        <Modal
            isOpen={true}
            onDismiss={onDismissCalendarSharingPermissions}
            isClickableOutsideFocusTrap={true}
            firstFocusableSelector="ms-BasePicker-input"
            isBlocking={false}>
            <CalendarSharingDialogComponent folderId={getStore().viewState.folderId} />
        </Modal>
    ) : null;
});
